import { Outlet } from 'react-router-dom';

export const GuardOutlet = () => <Outlet />;